import {MessarioLaunchMessage} from '@lib/messarioLaunch/types';

export function showMessarioLaunchMessage(message: MessarioLaunchMessage) {
  const show = () => {
    document.getElementById('messario-launch-message')?.remove();

    const overlay = document.createElement('div');
    overlay.id = 'messario-launch-message';
    overlay.setAttribute('role', 'alertdialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.style.cssText = [
      'position:fixed',
      'inset:0',
      'z-index:10000',
      'display:grid',
      'place-items:center',
      'padding:24px',
      'background:rgba(0,0,0,.55)'
    ].join(';');

    const card = document.createElement('section');
    card.style.cssText = [
      'max-width:480px',
      'padding:24px',
      'border-radius:12px',
      'background:var(--surface-color,#fff)',
      'color:var(--primary-text-color,#111)',
      'box-shadow:0 12px 48px rgba(0,0,0,.3)'
    ].join(';');

    const title = document.createElement('h2');
    title.textContent = message.title;
    title.style.cssText = 'margin:0 0 12px;font-size:20px';

    const description = document.createElement('p');
    description.textContent = message.description;
    description.style.cssText = 'margin:0 0 20px;line-height:1.45;white-space:pre-line';

    const close = document.createElement('button');
    close.type = 'button';
    close.textContent = 'Открыть Messario Web';
    close.style.cssText = [
      'display:block',
      'margin-left:auto',
      'padding:10px 16px',
      'border:0',
      'border-radius:8px',
      'background:var(--primary-color,#3390ec)',
      'color:#fff',
      'font:inherit',
      'cursor:pointer'
    ].join(';');
    close.addEventListener('click', () => overlay.remove());

    card.append(title, description, close);
    overlay.append(card);
    document.body.append(overlay);
    close.focus();
  };

  if(document.body) {
    show();
  } else {
    document.addEventListener('DOMContentLoaded', show, {once: true});
  }
}
